import { Flex } from "@gravity-ui/uikit";
import {
  ProductDetailResponseDto,
  ProductSourceDtoSourceEnum,
} from "definitions/product-storage";

import { PriceProps } from "../../../../PriceProps";
import { ProductContentDescription } from "../ProductContentDescription";
import { ProductPriceSection } from "../ProductPriceSection";
import { ProductPriceSource } from "../ProductPriceSource";

export interface ProductMobileLayoutProps {
  product: ProductDetailResponseDto;
  source: ProductDetailResponseDto["productSources"];
  platform: null | ProductSourceDtoSourceEnum;
  setPlatform: (platform: null | ProductSourceDtoSourceEnum) => void;
  reload: () => void;
  hasSubscribe?: boolean;
  priceProps: PriceProps;
}

export const ProductMobileLayout = ({
  product,
  source,
  platform,
  setPlatform,
  reload,
  hasSubscribe,
  priceProps,
}: ProductMobileLayoutProps) => {
  return (
    <Flex direction="column" gap="4">
      <ProductContentDescription product={product} />

      {hasSubscribe && (
        <ProductPriceSource
          source={source}
          platform={platform}
          reload={reload}
          setPlatform={setPlatform}
          isDesktop={false}
        />
      )}

      <ProductPriceSection
        {...priceProps}
        isDesktop={false}
        showSelectPlatformPrompt={false}
      />
    </Flex>
  );
};
